export const QA_NAME_MASS_ACTION = 'massAction'

export const QA_NAME_MASS_ACTION_MENU = 'massActionsMenu'

export const MASS_ACTION_DROPDOWN_MAX_HEIGHT = 360
